import { render, staticRenderFns } from "./VformCarouselDraggableDroppableMixin.js.vue?vue&type=template&id=5cf9af21&"
import script from "./VformCarouselDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"
export * from "./VformCarouselDraggableDroppableMixin.js.vue?vue&type=script&lang=js&"
import style0 from "./VformCarouselDraggableDroppableMixin.js.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports